export enum TechSector {
    HEATING = 'heating',
    FIRE_PROTECTION = 'fire-protection',
    WASTE_WATER = 'waste-water',
    WATER = 'water'
}